import React from "react";
import DataNotAvailableMessage from "./DataNotAvailableMessage";

type Props = {
  data: unknown;
  emptyMessage?: string;
};

const FormattedJson: React.FC<Props> = ({
  data,
  emptyMessage = "No data available",
}) => {
  if (!data || (typeof data === "object" && Object.keys(data).length === 0)) {
    return <DataNotAvailableMessage message={emptyMessage} />;
  }

  return (
    <div className="flex-1 rounded-md bg-gray-1 p-4">
      <pre className="font-mono text-sm text-gray-9">
        {JSON.stringify(data, null, 2)}
      </pre>
    </div>
  );
};

export default FormattedJson;
